import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";
import Footer from "../components/Footer";
import Header from "../components/Header";

function HistoryAll() {
    const [history, setHistory] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    function formatDate(m) {
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/payment/chuyentien`, {})
            .then((res) => {
                setHistory(res.data.data);
            })
            .catch((err) => function () {});
            
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    return (
        <AnimatedPage>
            <Header profile={profile} /> 

            <style>{`
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    overflow-y: auto !important;
                    background-color: #e3e1e2 !important; 
                    margin: 0; padding: 0;
                }
                
                .history-wrapper {
                    padding-bottom: 100px;
                    background-color: #e3e1e2;
                    min-height: 100vh;
                    padding-top: 15px;
                }

                /* ================================================== */
                /* 1. TIÊU ĐỀ TRANG VÀ NÚT BACK                       */
                /* ================================================== */
                .page-header-box {
                    display: flex;
                    align-items: center;
                    padding: 0 15px 20px 15px;
                    background: transparent;
                }
                .back-btn {
                    background: #fff;
                    color: #b71c1c;
                    width: 35px;
                    height: 35px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-right: 15px;
                }
                .back-btn:active { background: #f0f0f0; }
                .page-title-h1 {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                    margin: 0;
                    text-transform: uppercase;
                }

                /* ================================================== */
                /* 2. DANH SÁCH THẺ LỊCH SỬ                           */
                /* ================================================== */
                .history-content {
                    padding: 0 15px;
                }
                .history-card {
                    background: #fff;
                    border-radius: 8px;
                    padding: 15px;
                    margin-bottom: 12px;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.08);
                }
                .h-top {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 8px;
                    border-bottom: 1px solid #f0f0f0;
                    padding-bottom: 8px;
                }
                .h-type {
                    font-weight: bold;
                    font-size: 15px;
                    color: #333;
                }
                .h-status {
                    font-size: 12px;
                    font-weight: bold;
                    padding: 4px 8px;
                    border-radius: 4px;
                }
                .status-pending { background: #fff3cd; color: #ff9800; }
                .status-success { background: #e8f5e9; color: #4caf50; }
                .status-deny { background: #ffebee; color: #f44336; }
                .status-cancel { background: #f5f5f5; color: #9e9e9e; }

                .h-mid {
                    font-size: 13px;
                    color: #555;
                    margin-bottom: 8px;
                    line-height: 1.4;
                }

                .h-bot {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                }
                .h-money {
                    font-size: 16px;
                    font-weight: bold;
                    color: #b71c1c; /* Đỏ đô */
                }
                .h-date {
                    font-size: 12px;
                    color: #999;
                }
                
                .empty-history {
                    text-align: center;
                    color: #888;
                    margin-top: 50px;
                    font-size: 14px;
                }
            `}</style>

            <div className="history-wrapper">
                
                {/* 1. TIÊU ĐỀ TRANG */}
                <div className="page-header-box">
                    <h1 className="page-title-h1">Lịch sử chuyển điểm</h1>
                </div>

                {/* 2. NỘI DUNG LỊCH SỬ */}
                <div className="history-content">
                    {history && history.length > 0 ? (
                        history.map((item, index) => {
                            // Xác định class CSS cho trạng thái
                            let statusClass = "status-cancel";
                            let statusText = "Đã hủy";
                            
                            if (item?.status_payment === "Pending") {
                                statusClass = "status-pending";
                                statusText = "Đang xử lý";
                            } else if (item?.status_payment === "Success") {
                                statusClass = "status-success";
                                statusText = "Thành công";
                            } else if (item?.status_payment === "Deny") {
                                statusClass = "status-deny";
                                statusText = "Thất bại";
                            }

                            return (
                                <div className="history-card" key={index}>
                                    <div className="h-top">
                                        <div className="h-type">{item?.type_payment || "Giao dịch"}</div>
                                        <div className={`h-status ${statusClass}`}>
                                            {statusText}
                                        </div>
                                    </div>
                                    
                                    <div className="h-mid">
                                        Mã GD: <b>{item?.detail}</b>
                                    </div>
                                    
                                    <div className="h-bot">
                                        <div className="h-money">
                                            {/* Chia 1000 và hiển thị chữ Điểm */}
                                            {Math.floor((item?.money || 0) / 1000).toLocaleString("vi-VN")} Điểm
                                        </div>
                                        <div className="h-date">
                                            {formatDate(new Date(item?.createdAt))}
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="empty-history">
                            Chưa có dữ liệu lịch sử.
                        </div>
                    )}
                </div>
            </div>
            
            <Footer profile={profile} />
        </AnimatedPage>
    );
}

export default HistoryAll;